import * as Types from "../actions/action.types"
import * as Models from "../models/index"
export const defaultState = {
    messages: [] as Models.CorporateMessage[],
    warningMessages: [] as string[]
}
export type ReducerState = typeof defaultState;
export function reducer(state = defaultState, action: any): ReducerState {
    switch (action.type) {
        case Types.LOAD_INITIAL_DATA: {
            let payload = action.payload as Types.LOAD_INITIAL_DATA_PAYLOAD;
            return {
                ...state,
                messages: payload.messages,
                warningMessages: payload.warningMessages
            }
        }
        default:
            return state;
    }
}